export const configs = {
    "types": [
        {
            "id": "ml.t3.medium",
            "label": "ml.t3.medium"
        },
        {
            "id": "ml.t3.large",
            "label": "ml.t3.large"
        },
        {
            "id": "ml.t3.xlarge",
            "label": "ml.t3.xlarge"
        },
        {
            "id": "ml.t3.2xlarge",
            "label": "ml.t3.2xlarge"
        },
        {
            "id": "ml.t2.medium",
            "label": "ml.t2.medium"
        },
        {
            "id": "ml.t2.large",
            "label": "ml.t2.large"
        },
        {
            "id": "ml.t2.xlarge",
            "label": "ml.t2.xlarge"
        },
        {
            "id": "ml.t2.2xlarge",
            "label": "ml.t2.2xlarge"
        },
        {
            "id": "ml.m5.xlarge",
            "label": "ml.m5.xlarge"
        },
        {
            "id": "ml.m5.2xlarge",
            "label": "ml.m5.2xlarge"
        },
        {
            "id": "ml.m5.4xlarge",
            "label": "ml.m5.4xlarge"
        },
        {
            "id": "ml.m5.12xlarge",
            "label": "ml.m5.12xlarge"
        },
        {
            "id": "ml.m5.24xlarge",
            "label": "ml.m5.24xlarge"
        },
        {
            "id": "ml.m4.xlarge",
            "label": "ml.m4.xlarge"
        },
        {
            "id": "ml.m4.2xlarge",
            "label": "ml.m4.2xlarge"
        },
        {
            "id": "ml.m4.4xlarge",
            "label": "ml.m4.4xlarge"
        },
        {
            "id": "ml.m4.10xlarge",
            "label": "ml.m4.10xlarge"
        },
        {
            "id": "ml.m4.16xlarge",
            "label": "ml.m4.16xlarge"
        }
        
    ]
};
